#import '../../../../../common/components/DocumentPackageEmail/EmailDocumentFields.graphql'
#import "../../../../../common/components/DocumentPackageEmail/EntityEmailDocumentsFields.graphql"

query TravelAuthorizationEmailStatus($id: UUID!) {
  travelAuthorization(id: $id) {
    __typename
    id
    _rowTimestamp
    _emailDocument {
      ...EmailDocumentFields
    }
    travelAuthorizationEmailDocumentsByEntityId: emailDocumentsByEntityId(
      orderBy: [_CREATED_DATE_DESC, PRIMARY_KEY_ASC]
      filter: { _isTravelPlanEmail: { equalTo: false } }
    ) {
      nodes {
        ...EntityEmailDocumentsFields
      }
    }
  }
}
